'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
// import Config from '../config';
var $ = require("jquery");
var _func_1 = require("./_func");
var Order;
(function (Order) {
    var MyOrder = /** @class */ (function () {
        // private ext: string = 'jpg';
        function MyOrder(headerHeight, imagePosition) {
            var _this = this;
            if (headerHeight === void 0) { headerHeight = 0; }
            if (imagePosition === void 0) { imagePosition = 0; }
            this.headerHeight = headerHeight;
            this.imagePosition = imagePosition;
            var self = this;
            $('.trigOrderScroll').click(function () {
                var name = $(this).data('scroll');
                var minus = $('.bulletImageArea').height();
                var position = _func_1.default.getElementPosition('#bulletScroll-' + name, minus);
                _func_1.default.smoothScroll(position, true, 300);
            });
            /*
            // Header 固定パターン
            $(window).ready(() => {
                // .header の高さを .main の上余白に反映
                this.headerHeight = Number($('.header').outerHeight());
                $('.main').css({paddingTop: this.headerHeight});

                // イメージエリアの初期位置を取得
                this.imagePosition = $('.bulletImageArea').offset().top;
            });

            // セパイメージ図セクションまでスクロールしたら fixed になる
            $(window).scroll(() => {
                // スクロールイベント
                let sc = $(window).scrollTop();
                if(sc > this.imagePosition - this.headerHeight){
                    const bulletImageArea = $('.bulletImageArea');
                    bulletImageArea.css({position: 'fixed', top: this.headerHeight, left: 0, width: '100%', borderBottomColor: '#eee'});
                    $('.bulletBoxes').css({paddingTop: bulletImageArea.outerHeight()});
                }else{
                    $('.bulletImageArea').css({position: 'static', top: false, left: false, width: 'auto', borderBottomColor: '#fff'});
                    $('.bulletBoxes').css({paddingTop: 0});
                }
            });
*/
            // Header 固定しないパターン
            $(window).ready(function () {
                // 注文選択ページ
                if ($('#paramThisIsOrderSelectPage').val() == "1") {
                    // イメージエリアの初期位置を取得
                    _this.imagePosition = $('.bulletImageArea').offset().top;
                    // イメージエリアの画像サイズを設定
                    MyOrder.resetOrderImageAreaSize();
                    // パラメーター値を表示に反映
                    var D = MyOrder.getParameters();
                    MyOrder.setInitialSelect(D);
                    // console.log(D);
                }
                // トップページ
                if ($('#paramThisIsTopPage').val() == "1") {
                    MyOrder.resetQuickRectImageAreaSize();
                }
                // カートページ
                if ($('#paramThisIsOrderCartPage').val() == "1") {
                    MyOrder.resetQuickSquareImageAreaSize();
                }
                // おすすめセパ一覧ページ（Admin）
                if ($('#paramThisIsAdminPushItemListPage').val() == "1") {
                    MyOrder.resetAdminPushItemListImageAreaSize();
                }
                // おすすめセパ登録ページ（Admin）
                if ($('#paramThisIsAdminPushItemCreatePage').val() == "1") {
                    // パラメーター値を表示に反映
                    var D = MyOrder.getParameters();
                    MyOrder.setInitialSelect(D);
                    // おすすめセパ作成のイメージサイズ取得
                    MyOrder.resetAdminPushItemCreateImageAreaSize();
                }
            });
            // クイックオーダーのイメージサイズ再取得
            $(window).resize(function () {
                if ($('#paramThisIsTopPage').val() == "1") {
                    MyOrder.resetQuickRectImageAreaSize();
                }
                if ($('#paramThisIsAdminPushItemListPage').val() == "1") {
                    MyOrder.resetAdminPushItemListImageAreaSize();
                }
            });
            // セパイメージ図セクションまでスクロールしたら fixed になる
            if ($('#paramThisIsOrderSelectPage').val() == "1") {
                $(window).scroll(function () {
                    // スクロールイベント
                    var sc = $(window).scrollTop();
                    if (sc > _this.imagePosition - _this.headerHeight) {
                        var bulletImageArea = $('.bulletImageArea');
                        bulletImageArea.css({ position: 'fixed', top: _this.headerHeight, left: 0, width: '100%', borderBottomColor: '#eee' });
                        $('.bulletBoxes').css({ paddingTop: bulletImageArea.outerHeight() });
                        $('.bulletImageTitle').slideDown();
                    }
                    else {
                        $('.bulletImageArea').css({ position: 'relative', top: false, left: false, width: 'auto', borderBottomColor: '#fff', backgroundColor: '#fff', zIndex: 10 });
                        $('.bulletBoxes').css({ paddingTop: 0 });
                        $('.bulletImageTitle').hide();
                    }
                });
            }
            // 注文：選択肢
            $(document).on('click', 'button.trigSelect', function () {
                // ボタンが無効状態か確認
                if (MyOrder.checkDisable($(this))) {
                    return false;
                }
                var name = $(this).attr('data-name');
                var side = $(this).attr('data-side');
                var value = $(this).attr('data-value');
                // console.log([name, side, value]);
                // 共通処理
                MyOrder.setThisSelect(name, side, value);
                MyOrder.setThisButton(name, side, value);
                MyOrder.showThisOptionValues(name, side, value);
                // input値を更新
                if (name == 'stopper') {
                    // 止水板のボタンを押した時
                    MyOrder.setStopperInputValue(value);
                }
                else {
                    // 止水板以外のボタンを押した時
                    MyOrder.setInputValue(name, side, value);
                }
                // チューブコンのサイズ選択ボタン開閉
                if (name == 'main') {
                    MyOrder.setTubeButtonByMain(side, value);
                }
            });
            // 数値入力欄
            $(document).on('click', '.trigInputNumber', function () {
                if ($('#paramThisIsOrderSelectPage').val() == "1") {
                    $('.bulletImageArea').animate({ marginTop: '-200px' }, 300);
                    var id = $(this).attr('id');
                    var elm = document.getElementById(id);
                    elm.setSelectionRange(100, 100);
                }
            });
            $(document).on('blur', '.trigInputNumber', function () {
                if ($('#paramThisIsOrderSelectPage').val() == "1") {
                    $('.bulletImageArea').animate({ marginTop: 0 }, 300);
                }
            });
            // 注文：入力
            $(document).on('keyup', 'input.trigSelect', function () {
                var name = $(this).attr('data-name');
                var side = $(this).attr('data-side');
                var value = $(this).val();
                // console.log([name, side, value]);
                MyOrder.setThisSelect(name, side, value);
            });
            // 曲げ角度選択エリア表示
            $('.trigOpenCurlValue').click(function () {
                var side = $(this).attr('data-side');
                $('.bulletOpenCurlValue[data-side="' + side + '"]').show();
            });
            // 曲げ角度選択エリア非表示
            $('.trigCloseCurlValue').click(function () {
                $('.bulletOpenCurlValue').hide();
            });
            // 軸長の入力値を制限
            $('.trigSelect[data-name="long_value"]').keyup(function () {
                var val = $(this).val();
                var side = $(this).attr('data-side');
                MyOrder.checkLongValue(val, side);
            });
        }
        // オーダー最上部の画像サイズを再設定
        MyOrder.resetOrderImageAreaSize = function () {
            var windowWidth = $(window).width();
            if (windowWidth >= 1025) {
                $('.bulletImage').width(800 * 0.34).height(800 * 0.34 / 168 * 96);
                $('.bulletImageStopper').width(800 * 0.32).height(800 * 0.32 / 168 * 96);
                $('.bulletImageArea img').width('100%');
                $('.bulletBase img').width(800 * 0.34);
                $('.bulletFakeBase img').width(800 * 0.34);
            }
            // const paramWidth = MyOrder.getRectImageAreaSize( windowWidth );
            // $('.bulletQuickorderImageArea').width(paramWidth).height( paramWidth / 168 * 96 );
            // $('.bulletQuickImageAreaWrap img').width(paramWidth);
        };
        // .ready()
        // おすすめセパ一覧のイメージサイズ取得
        MyOrder.resetAdminPushItemListImageAreaSize = function () {
            var contentWidth = $('.paramQuickorderImageBlock').width();
            var paramWidth = (contentWidth) * 0.34;
            var paramHeight = paramWidth / 168 * 96;
            $('.bulletQuickorderImageArea').width(paramWidth).height(paramHeight);
            $('.bulletQuickImageAreaWrap img').width(paramWidth);
        };
        // おすすめセパ作成のイメージサイズ取得
        MyOrder.resetAdminPushItemCreateImageAreaSize = function () {
            var contentWidth = $('.content-wrapper').width();
            var boxWidth = contentWidth * 0.4;
            var paramWidth = boxWidth * 0.34;
            var paramHeight = paramWidth / 168 * 96;
            $('.bulletPushItemImage').width(boxWidth);
            $('.bulletPushItemImageArea').width(paramWidth).height(paramHeight);
            $('.bulletPushItemImageLayer img').width(paramWidth);
            var paramStopperWidth = boxWidth * 0.32;
            $('.bulletPushItemStopperImageArea').width(paramStopperWidth).height(paramHeight);
        };
        // クイックオーダーの画像サイズを再設定
        MyOrder.resetQuickRectImageAreaSize = function () {
            var windowWidth = $(window).width();
            var paramWidth = MyOrder.getRectImageAreaSize(windowWidth);
            $('.bulletQuickorderImageArea').width(paramWidth).height(paramWidth / 168 * 96);
            $('.bulletQuickImageAreaWrap img').width(paramWidth);
        };
        MyOrder.getRectImageAreaSize = function (windowWidth) {
            // root/html/shared/css/scss/top/_quickorder.scss
            if (windowWidth <= 480) {
                // padding:20 > margin: 4 padding:5,40 36% > side 34%
                return (windowWidth - 20 - 4 - 45) * 0.36 * 0.34;
            }
            else if (windowWidth >= 481 && windowWidth <= 1024) {
                if (windowWidth > 960) {
                    windowWidth = 960;
                }
                // padding: 20 > 50% - 10px > margin: 4 padding:5,40 36% > side 34%
                return (((windowWidth - 20) * 0.5 - 10) - 4 - 45) * 0.36 * 0.34;
            }
            else if (windowWidth >= 1025) {
                // 18vw padding:20px margin:6% side 34%
                windowWidth = 960;
                // 50% - 10px > margin: 4 padding:5,40 36% > side 34%
                return ((windowWidth * 0.5 - 10) - 4 - 45) * 0.36 * 0.34;
            }
        };
        // クイックオーダーの画像サイズを再設定
        MyOrder.resetQuickSquareImageAreaSize = function () {
            var windowWidth = $(window).width();
            var paramWidth = MyOrder.getSquareImageAreaSize(windowWidth);
            $('.bulletQuickorderImageArea').width(paramWidth).height(paramWidth / 168 * 96);
            $('.bulletQuickImageAreaWrap img').width(paramWidth);
        };
        MyOrder.getSquareImageAreaSize = function (windowWidth) {
            // root/html/shared/css/scss/top/_quickorder.scss
            if (windowWidth <= 480) {
                // 40vw padding:20px margin:6% > side 34%
                return (windowWidth * 0.4 - 20) * 0.88 * 0.34;
            }
            else if (windowWidth >= 481 && windowWidth <= 1024) {
                // 25vw padding:20px margin:6% > side 34%
                return (windowWidth * 0.25 - 20) * 0.88 * 0.34;
            }
            else if (windowWidth >= 1025) {
                // 18vw padding:20px margin:6% > side 34%
                return (windowWidth * 0.18 - 20) * 0.88 * 0.34;
            }
        };
        MyOrder.getParameters = function () {
            var D = {
                mainLeft: $('input[name="main_left"]').val(),
                mainRight: $('input[name="main_right"]').val(),
                tubeSizeLeft: $('input[name="tube_size_left"]').val(),
                tubeSizeRight: $('input[name="tube_size_right"]').val(),
                wingLeft: $('input[name="wing_left"]').val(),
                wingRight: $('input[name="wing_right"]').val(),
                length: $('input[name="length"]').val(),
                quantity: $('input[name="quantity"]').val(),
                curlLeft: $('input[name="curl_left"]').val(),
                curlRight: $('input[name="curl_right"]').val(),
                curlValueIdLeft: $('input[name="curl_value_id_left"]').val(),
                curlValueIdRight: $('input[name="curl_value_id_right"]').val(),
                stopper: $('input[name="stopper"]').val(),
                longLeft: $('input[name="long_left"]').val(),
                longRight: $('input[name="long_right"]').val(),
                longValueLeft: $('input[name="long_value_left"]').val(),
                longValueRight: $('input[name="long_value_right"]').val(),
            };
            return D;
        };
        MyOrder.setInitialSelect = function (D) {
            // main
            if (D.mainLeft) {
                MyOrder.hideFake('left');
            }
            if (D.mainRight) {
                MyOrder.hideFake('right');
            }
            MyOrder.setMainImage('left', D.mainLeft);
            MyOrder.setMainImage('right', D.mainRight);
            MyOrder.setThisButton('main', 'left', D.mainLeft);
            MyOrder.setThisButton('main', 'right', D.mainRight);
            // チューブコン
            MyOrder.setTubeSizeImage('left', D.tubeSizeLeft);
            MyOrder.setTubeSizeImage('right', D.tubeSizeRight);
            MyOrder.setTubeSizeImageByMain('left', D.mainLeft);
            MyOrder.setTubeSizeImageByMain('right', D.mainRight);
            MyOrder.setTubeButtonByMain('left', D.mainLeft);
            MyOrder.setTubeButtonByMain('right', D.mainRight);
            MyOrder.setTubeSizeButtonByMain('left', D.mainLeft);
            MyOrder.setTubeSizeButtonByMain('right', D.mainRight);
            // wing
            MyOrder.setWingImageByMain('left', D.mainLeft);
            MyOrder.setWingImageByMain('right', D.mainRight);
            MyOrder.setWingButtonByMain('left', D.mainLeft);
            MyOrder.setWingButtonByMain('right', D.mainRight);
            // length
            MyOrder.setLengthParameter(D.length);
            // quantity
            MyOrder.setQuantityParameter(D.quantity);
            // curl
            MyOrder.setCurlImage('left', D.curlLeft);
            MyOrder.setCurlImage('right', D.curlRight);
            MyOrder.setThisButton('curl', 'left', D.curlLeft);
            MyOrder.setThisButton('curl', 'right', D.curlRight);
            // curl_value
            MyOrder.setCurlValueImage('left', D.curlLeft, D.curlValueIdLeft);
            MyOrder.setCurlValueImage('right', D.curlRight, D.curlValueIdRight);
            MyOrder.setThisButton('curl_value_id', 'left', D.curlValueIdLeft);
            MyOrder.setThisButton('curl_value_id', 'right', D.curlValueIdRight);
            // stopper
            MyOrder.setStopperImage(D.stopper);
            MyOrder.setThisButton('stopper', undefined, D.stopper);
            // long
            MyOrder.setLongImage('left', D.longLeft);
            MyOrder.setLongImage('right', D.longRight);
            MyOrder.setThisButton('long', 'left', D.longLeft);
            MyOrder.setThisButton('long', 'right', D.longRight);
            // long_value
            MyOrder.setLongValueParameter('left', D.longLeft, D.longValueLeft);
            MyOrder.setLongValueParameter('right', D.longRight, D.longValueRight);
            MyOrder.showThisOptionValues('long', 'left', D.longLeft);
            MyOrder.showThisOptionValues('long', 'right', D.longRight);
            // 軸長の始末
            MyOrder.setLongImageByMain('left', D.mainLeft);
            MyOrder.setLongImageByMain('right', D.mainRight);
            MyOrder.setLongButtonByMain('left', D.mainLeft);
            MyOrder.setLongButtonByMain('right', D.mainRight);
            MyOrder.viewLongOptionByMain('left', D.mainLeft);
            MyOrder.viewLongOptionByMain('right', D.mainRight);
            MyOrder.setLongValueParameterByMain('left', D.mainLeft);
            MyOrder.setLongValueParameterByMain('right', D.mainRight);
            // 曲げ勾配
            MyOrder.viewCurlValueOption('left');
            MyOrder.viewCurlValueOption('right');
        };
        // Image
        MyOrder.setThisSelect = function (name, side, value) {
            switch (name) {
                case 'main':
                    MyOrder.hideFake(side);
                    MyOrder.setMainImage(side, value);
                    // チューブコンの始末
                    MyOrder.setTubeSizeImageByMain(side, value);
                    // 蝶（羽根）の始末
                    MyOrder.setWingImageByMain(side, value);
                    MyOrder.setWingButtonByMain(side, value);
                    // 軸長の始末
                    MyOrder.setLongImageByMain(side, value);
                    MyOrder.setLongButtonByMain(side, value);
                    MyOrder.viewLongOptionByMain(side, value);
                    MyOrder.setLongValueParameterByMain(side, value);
                    break;
                case 'tube-size':
                    MyOrder.setTubeSizeImage(side, value);
                    break;
                case 'wing':
                    MyOrder.setWingImage(side, value);
                    break;
                case 'length':
                    MyOrder.setLengthParameter(value);
                    break;
                case 'quantity':
                    MyOrder.setQuantityParameter(value);
                    break;
                case 'curl':
                    MyOrder.setCurlImage(side, value);
                    MyOrder.setCurlValueImage(side, value);
                    break;
                case 'curl_value_id':
                    MyOrder.setCurlValueImage(side, "1", value);
                    break;
                case 'stopper':
                    MyOrder.setStopperImage(value);
                    break;
                case 'long':
                    MyOrder.setLongImage(side, value);
                    MyOrder.setLongValueParameter(side, value);
                    break;
                case 'long_value':
                    MyOrder.setLongValueParameter(side, "1", value);
                    break;
            }
        };
        MyOrder.checkDisable = function (elm) {
            return elm.attr('data-disable') == "1";
        };
        // first select
        MyOrder.hideFake = function (side) {
            $('.bulletFakeImage[data-side=' + side + ']').hide();
            $('.bulletFakeBase').hide();
            $('.bulletBase').show();
        };
        // input
        MyOrder.setInputValue = function (name, side, value) {
            $('.bulletSelect[data-name="' + name + '"][data-side="' + side + '"]').val(value);
        };
        MyOrder.setStopperInputValue = function (value) {
            $('.bulletSelect[data-name="stopper"]').val(value);
        };
        // Image
        MyOrder.setMainImage = function (side, value) {
            $('.bulletImage[data-name="main"][data-side="' + side + '"]').hide();
            $('.bulletImage[data-name="main"][data-side="' + side + '"][data-value="' + value + '"]').show();
        };
        MyOrder.setTubeSizeImage = function (side, value) {
            $('.bulletImage[data-name="tube-size"][data-side="' + side + '"]').html(value);
        };
        MyOrder.setWingImage = function (side, value) {
            if (value == "1") {
                $('.bulletImage[data-name="wing"][data-side="' + side + '"]').show();
            }
            else {
                $('.bulletImage[data-name="wing"][data-side="' + side + '"]').hide();
            }
        };
        MyOrder.setCurlImage = function (side, value) {
            if (value == "0") {
                $('.bulletImage[data-name="curl"][data-side="' + side + '"]').css('transform', 'none');
            }
            else {
                var curlValueId = $('.trigSelect[data-name=curl_value_id][data-side="' + side + '"]').val();
                MyOrder.setCurlValueImage(side, "1", curlValueId);
            }
        };
        MyOrder.setCurlValueImage = function (side, value, curlValueId) {
            if (curlValueId === void 0) { curlValueId = undefined; }
            if (curlValueId === undefined) {
                curlValueId = $('.bulletSelect[data-name="curl_value_id"][data-side="' + side + '"]').val();
            }
            var deg = _func_1.default.getDeg(curlValueId);
            var curlValue = _func_1.default.getCurlValue(curlValueId);
            if (value == "1") {
                if (side == 'right') {
                    deg = deg * -1;
                }
                $('.bulletImage[data-name="curl"][data-side="' + side + '"]').css('transform', 'rotate(' + deg + 'deg)');
                $('.bulletValue[data-name="curl"][data-side="' + side + '"]').html(MyOrder.getCurlName(curlValue));
                $('.bulletValueBox[data-name="curl"][data-side="' + side + '"]').attr('data-active', 1);
                $('.bulletCurlValue[data-side="' + side + '"]').html(MyOrder.getCurlName(curlValue));
            }
            else {
                $('.bulletImage[data-name="curl"][data-side="' + side + '"]').css('transform', 'none');
                $('.bulletValue[data-name="curl"][data-side="' + side + '"]').html("-");
                $('.bulletValueBox[data-name="curl"][data-side="' + side + '"]').attr('data-active', 0);
                $('.bulletCurlValue[data-side="' + side + '"]').html('曲げ勾配を選ぶ');
            }
        };
        MyOrder.getCurlName = function (curlValue) {
            var body = '曲げ勾配を選ぶ';
            if (curlValue == '20分') {
                body = '90度';
            }
            else if (curlValue) {
                body = curlValue;
            }
            return body;
        };
        MyOrder.setStopperImage = function (value) {
            $('.bulletImage[data-name="stopper"]').hide();
            if (value != "0") {
                $('.bulletImage[data-name="stopper"][data-size="' + value + '"]').show();
            }
        };
        MyOrder.setLongImage = function (side, value) {
            if (value == "1") {
                $('.bulletImage[data-name="long"][data-side="' + side + '"]').show();
            }
            else {
                $('.bulletImage[data-name="long"][data-side="' + side + '"]').hide();
            }
        };
        // Button
        MyOrder.setThisButton = function (name, side, value) {
            if (side != undefined) { // main, wing, curl, curl_value, long, long_value
                $('.trigSelect[data-name="' + name + '"][data-side="' + side + '"]').removeClass('selected');
                $('.trigSelect[data-name="' + name + '"][data-side="' + side + '"][data-value="' + value + '"]').addClass('selected');
            }
            else { // stopper, length, quantity
                $('.trigSelect[data-name="' + name + '"]').removeClass('selected');
                $('.trigSelect[data-name="' + name + '"][data-value="' + value + '"]').addClass('selected');
            }
        };
        // Parameter
        MyOrder.setLengthParameter = function (value) {
            $('.bulletValue[data-name="length"]').html(value);
        };
        MyOrder.setQuantityParameter = function (value) {
            $('.bulletValue[data-name="quantity"]').html(value);
        };
        MyOrder.setLongValueParameter = function (side, value, longValue) {
            if (longValue === void 0) { longValue = undefined; }
            if (longValue === undefined) {
                longValue = $('.trigSelect[data-name="long_value"][data-side="' + side + '"]').val() || "-";
            }
            if (value == "1") {
                $('.bulletValue[data-name="long"][data-side="' + side + '"]').html(longValue);
                $('.bulletValueBox[data-name="long"][data-side="' + side + '"]').attr('data-active', 1);
            }
            else {
                $('.bulletValue[data-name="long"][data-side="' + side + '"]').html("-");
                $('.bulletValueBox[data-name="long"][data-side="' + side + '"]').attr('data-active', 0);
            }
        };
        // other
        MyOrder.showThisOptionValues = function (name, side, value) {
            if (name == 'curl' || name == 'long') {
                if (value == "1") {
                    $('.bulletOptionValues[data-name="' + name + '"][data-side="' + side + '"]').show();
                }
                else {
                    $('.bulletOptionValues[data-name="' + name + '"][data-side="' + side + '"]').hide();
                }
            }
        };
        // ByMain - Image
        MyOrder.setTubeSizeImageByMain = function (side, main) {
            if (main == 'tube') {
                var tubeSize = $('.bulletSelect[data-name="tube-size"][data-side="' + side + '"]').val() || "";
                $('.bulletImage[data-name="tube-size"][data-side="' + side + '"]').html(tubeSize);
            }
            else {
                $('.bulletImage[data-name="tube-size"][data-side="' + side + '"]').html("");
            }
        };
        MyOrder.setWingImageByMain = function (side, main) {
            if (main == 'B' || main == 'stad' || main == 'tube') {
                $('.bulletImage[data-name="wing"][data-side="' + side + '"]').hide();
            }
            else {
                var wing = $('.bulletSelect[data-name="wing"][data-side="' + side + '"]').val() || "0";
                if (wing == "1") {
                    $('.bulletImage[data-name="wing"][data-side="' + side + '"]').show();
                }
                else {
                    $('.bulletImage[data-name="wing"][data-side="' + side + '"]').hide();
                }
            }
        };
        MyOrder.setLongImageByMain = function (side, main) {
            if (main == 'B' || main == 'stad' || main == 'tube') {
                MyOrder.setLongImage(side, "0");
            }
            else {
                var long = $('.bulletSelect[data-name="long"][data-side="' + side + '"]').val() || "0";
                MyOrder.setLongImage(side, long);
            }
        };
        // ByMain - Button
        MyOrder.setTubeButtonByMain = function (side, main) {
            if (main == 'tube') {
                // $('.bulletTubeSizes[data-side="' + side + '"]').animate({marginTop: 0}, 300, 'swing');
                $('.bulletTubeSizes[data-side="' + side + '"]').attr("data-visible", "show");
                $('.bulletTubeSize[data-side="' + side + '"][data-value="40"]').animate({ left: 0 }, 300, 'swing');
                $('.bulletTubeSize[data-side="' + side + '"][data-value="80"]').animate({ left: '68%' }, 300, 'swing');
            }
            else {
                // $('.bulletTubeSizes[data-side="' + side + '"]').animate({marginTop: '-40%'}, 100);
                $('.bulletTubeSizes[data-side="' + side + '"]').attr("data-visible", "hide");
                $('.bulletTubeSize[data-side="' + side + '"]').animate({ left: '34%' }, 100);
            }
        };
        MyOrder.setTubeSizeButtonByMain = function (side, main) {
            if (main == 'tube') {
                var tubeSize = $('.bulletSelect[data-name="tube-size"][data-side="' + side + '"]').val() || "0";
                $('.trigSelect[data-name="tube-size"][data-side="' + side + '"]').removeClass('selected').attr('data-disable', 0);
                $('.trigSelect[data-name="tube-size"][data-side="' + side + '"][data-value="' + tubeSize + '"]').addClass('selected');
            }
        };
        MyOrder.setWingButtonByMain = function (side, main) {
            if (main == 'B' || main == 'stad' || main == 'tube') {
                $('.trigSelect[data-name="wing"][data-side="' + side + '"]').removeClass('selected').attr('data-disable', 1);
            }
            else {
                var wing = $('.bulletSelect[data-name="wing"][data-side="' + side + '"]').val() || "0";
                $('.trigSelect[data-name="wing"][data-side="' + side + '"]').removeClass('selected').attr('data-disable', 0);
                $('.trigSelect[data-name="wing"][data-side="' + side + '"][data-value="' + wing + '"]').addClass('selected');
            }
        };
        MyOrder.setLongButtonByMain = function (side, main) {
            if (main == 'B' || main == 'stad' || main == 'tube') {
                $('.trigSelect[data-name="long"][data-side="' + side + '"]').removeClass('selected').attr('data-disable', 1);
            }
            else {
                var long = $('.bulletSelect[data-name="long"][data-side="' + side + '"]').val() || "0";
                $('.trigSelect[data-name="long"][data-side="' + side + '"]').removeClass('selected').attr('data-disable', 0);
                $('.trigSelect[data-name="long"][data-side="' + side + '"][data-value="' + long + '"]').addClass('selected');
            }
        };
        // ByMain - Parameter
        MyOrder.setLongValueParameterByMain = function (side, main) {
            if (main == 'B' || main == 'stad' || main == 'tube') {
                $('.bulletValue[data-name="long"][data-side="' + side + '"]').html("-");
                $('.bulletValueBox[data-name="long"][data-side="' + side + '"]').attr('data-active', 0);
            }
            else {
                var long = $('.bulletSelect[data-name="long"][data-side="' + side + '"]').val() || "0";
                if (long == "1") {
                    var longValue = $('.trigSelect[data-name="long_value"][data-side="' + side + '"]').val() || "-";
                    $('.bulletValue[data-name="long"][data-side="' + side + '"]').html(longValue);
                    $('.bulletValueBox[data-name="long"][data-side="' + side + '"]').attr('data-active', 1);
                }
                else {
                    $('.bulletValue[data-name="long"][data-side="' + side + '"]').html("-");
                    $('.bulletValueBox[data-name="long"][data-side="' + side + '"]').attr('data-active', 0);
                }
            }
        };
        // ByMain - other
        MyOrder.viewCurlValueOption = function (side) {
            var curl = $('.bulletSelect[data-name="curl"][data-side="' + side + '"]').val() || "0";
            if (curl == "1") {
                $('.bulletOptionValues[data-name="curl"][data-side="' + side + '"]').show();
            }
            else {
                $('.bulletOptionValues[data-name="curl"][data-side="' + side + '"]').hide();
            }
        };
        MyOrder.viewLongOptionByMain = function (side, main) {
            if (main == 'B' || main == 'stad' || main == 'tube') {
                $('.bulletOptionValues[data-name="long"][data-side="' + side + '"]').hide();
            }
            else {
                var long = $('.bulletSelect[data-name="long"][data-side="' + side + '"]').val() || "0";
                if (long == "1") {
                    $('.bulletOptionValues[data-name="long"][data-side="' + side + '"]').show();
                }
                else {
                    $('.bulletOptionValues[data-name="long"][data-side="' + side + '"]').hide();
                }
            }
        };
        MyOrder.checkLongValue = function (val, side) {
            $('.alertLongValue').hide();
            if (val) {
                if (Number(val) < 0) {
                    val = 0;
                    $('.alertLongValue').show();
                    $('.trigSelect[data-name="long_value"][data-side="' + side + '"]').val(val);
                }
                else if (Number(val) > 32) {
                    val = 32;
                    $('.alertLongValue').show();
                    $('.trigSelect[data-name="long_value"][data-side="' + side + '"]').val(val);
                }
            }
        };
        return MyOrder;
    }());
    Order.MyOrder = MyOrder;
})(Order || (Order = {}));
exports.default = Order;
